// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { onePageCheckoutShippingSectionStyles } from "@sc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import ChangeBranch from "@sc/XDL/Icons/ChangeBranch";
import { color, createLinkIconStyles, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const sectionWrapperStyles = css`
    width: calc((100% - 44px) / 3);
    ${xScreen("lte", "md")} {
        width: 100%;
    }
`;
const wrapperStyles = css`
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 13px;
    border: 1px solid ${color("common.border")};
    border-radius: 4px;
`;

onePageCheckoutShippingSectionStyles.shipToNote = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-top: 4px;
                flex-wrap: nowrap;
                ${xScreen("lte", "xs")} {
                    flex-wrap: nowrap;
                }
            `,
        },
    }),
};

onePageCheckoutShippingSectionStyles.sectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 13px;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        width: calc((100% - 44px) / 3);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

onePageCheckoutShippingSectionStyles.billToSectionWrapper = {
    css: css`
        ${sectionWrapperStyles}
    `,
};
onePageCheckoutShippingSectionStyles.billToWrapper = {
    css: css`
        ${wrapperStyles}
    `,
};
onePageCheckoutShippingSectionStyles.pickupSectionWrapper = {
    css: css`
        ${sectionWrapperStyles}
    `,
};
onePageCheckoutShippingSectionStyles.pickupWrapper = {
    css: css`
        ${wrapperStyles}
        ${({ fullHeight }: any) => (fullHeight ? "height: 100%;" : "")}
    `,
};
onePageCheckoutShippingSectionStyles.editLink = {
    ...createLinkIconStyles(ChangeBranch),
};

onePageCheckoutShippingSectionStyles.addressWrapper = {
    css: css`
        margin-top: 4px;
    `,
};
onePageCheckoutShippingSectionStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 24px;
    `,
};
onePageCheckoutShippingSectionStyles.titleText = {
    variant: "h3",
    forwardAs: "h2",
    css: css`
        margin-bottom: -8px;
        width: 100%;
    `,
};
onePageCheckoutShippingSectionStyles.addressTextStyle = {
    css: css`
        margin-bottom: 0;
    `,
};
onePageCheckoutShippingSectionStyles.fieldWrapper = {
    css: css`
        margin-top: 16px;
    `,
};
onePageCheckoutShippingSectionStyles.saveButton = {
    css: css`
        margin-top: 16px;
    `,
};
